import { getEnabled } from "../config/config-store";
import { handleError } from "../utils/handle-error";
import { eventTypes } from "../types/event-types";
import { getUserProfileId } from "../user/user-store";
import { getLoggerEnabled } from "../logger/logger-store";
const createEvents = () => {
    const rumSend = (data) => {
        if (getEnabled) {
            if (getLoggerEnabled())
                console.log("[Passive] rumSend:", data);
            const [metaError, metaResult] = handleError(() => cwr("recordEvent", { type: eventTypes.journeyRecord, data }));
            if (metaError) {
                console.warn("[Passive] Error executing CWR event:", metaError);
                return;
            }
        }
    };
    const rumSendPageView = (data) => {
        if (getEnabled) {
            if (getLoggerEnabled())
                console.log("[Passive] rumSendPageView:", data);
            const [metaError, metaResult] = handleError(() => cwr("recordPageView", {
                pageId: data,
                userProfileId: getUserProfileId(),
            }));
            if (metaError) {
                console.warn("[Passive] Error executing CWR event:", metaError);
                return;
            }
        }
    };
    const rumSendAddSessionAttributes = (data) => {
        if (getEnabled) {
            if (getLoggerEnabled())
                console.log("[Passive] rumSendAddSessionAttributes:", data);
            const [metaError, metaResult] = handleError(() => cwr("addSessionAttributes", data));
            if (metaError) {
                console.warn("[Passive] Error executing CWR event:", metaError);
                return;
            }
        }
    };
    const rumSendDisableCookies = () => {
        if (getEnabled) {
            if (getLoggerEnabled())
                console.log("[Passive] rumSendDisableCookies");
            const [metaError, metaResult] = handleError(() => cwr("allowCookies", false));
            if (metaError) {
                console.warn("[Passive] Error executing CWR event:", metaError);
                return;
            }
        }
    };
    return {
        rumSend,
        rumSendPageView,
        rumSendAddSessionAttributes,
        rumSendDisableCookies,
    };
};
export const { rumSend, rumSendPageView, rumSendAddSessionAttributes, rumSendDisableCookies, } = createEvents();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/rum/rum-event.js
// module id = ./node_modules/@celine/passive-tracking/dist/rum/rum-event.js
// module chunks = 0